/** @jsxImportSource @emotion/react */
import { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useSearchParams,
  useLocation,
  useNavigate
} from "react-router-dom";

import { readFromLS, ArchivoPreviewPage, ConPermiso } from "./shared";

import Login from "./secciones/login/Login";
import Tablero from "./secciones/home/Tablero.js";
import Normas from "./secciones/config/norma/lista/Normas";
import Norma from "./secciones/config/norma/individual/Norma";
import Muestras from "./secciones/muestra/lista/Muestras";
import Muestra from "./secciones/muestra/individual/Muestra";
import Caja from "./secciones/caja/individual/Caja";
import ConfigPortada from "./secciones/config/Portada";
import GeneralConfig from "./secciones/config/GeneralConfig";
import Integraciones from "./secciones/config/Integraciones";
import Administradores from "./secciones/config/administrador/lista/Administradores";
import Administrador from "./secciones/config/administrador/individual/Administrador";
import ProcesoTipos from "./secciones/config/procesoTipos/ProcesoTipos";
import Contadores from "./secciones/config/contadores/Contadores";
import Numeracion from "./secciones/config/numeracion/Numeracion";
import ProcesosCliente from "./secciones/proceso/lista/ProcesosCliente.js";
import ProcesoLayout from "./secciones/proceso/individual/ProcesoLayout.js";
import ProcesoDetalles from "./secciones/proceso/individual/ProcesoDetalles.js";
import ProcesoProductos from "./secciones/proceso/individual/ProcesoProductos.js";
import ProcesoCertificado from "./secciones/proceso/individual/ProcesoCertificado.js";
import Solicitud from "./secciones/solicitud/Solicitud";
import PropuestaComercial from "./secciones/propuestaComercial/PropuestaComercial";
import PropuestaSabana from "./secciones/propuestaSabana/PropuestaSabana";
import PropuestaSabanaNueva from "./secciones/propuestaSabana/PropuestaSabanaNueva";
import NuevoProceso from "./secciones/proceso/NuevoProceso";
import Certificado from "./secciones/certificado/Certificado";
import Clientes from "./secciones/cliente/lista/Clientes";
import ClienteLayout from "./secciones/cliente/individual/ClienteLayout.js";
import ClienteInformacion from "./secciones/cliente/individual/ClienteInformacion.js";
import ClienteSitios from "./secciones/cliente/individual/ClienteSitios.js";
import ClienteFacturas from "./secciones/cliente/individual/ClienteFacturas.js";
import ClienteConfiguracion from "./secciones/cliente/individual/ClienteConfiguracion.js";
import Laboratorios from "./secciones/config/laboratorio/lista/Laboratorios";
import Laboratorio from "./secciones/config/laboratorio/individual/Laboratorio";
import Esquemas from "./secciones/config/esquemas/lista/Esquemas";
import Esquema from "./secciones/config/esquemas/individual/Esquema";
import Reporte from "./secciones/config/reporte/Reporte";
import CertificadoTipos from "./secciones/config/certificadoTipo/lista/CertificadoTipos";
import CertificadoTipo from "./secciones/config/certificadoTipo/individual/CertificadoTipo.js";
import Auditores from "./secciones/config/auditor/lista/Auditores";
import Auditor from "./secciones/config/auditor/individual/Auditor";
import AuditorTipos from "./secciones/config/auditor/AuditorTipos";
import AuditorTipoDetalle from "./secciones/config/auditor/AuditorTipoDetalle";
import BusquedaResultado from "./secciones/busquedaResultado/BusquedaResultado";
import Comunicaciones from "./secciones/config/comunicaciones/Comunicaciones.js";
import NotFound from "./secciones/notFound/NotFound";
import { useRol } from "./roles";
import JuguetesOperaciones from "./secciones/juguetes/JuguetesOperaciones";
import Eventos from "./secciones/config/eventos/lista/Eventos";
import Evento from "./secciones/config/eventos/individual/Evento";
import Enviados from "./secciones/config/eventos/enviados/Enviados";
import ActividadesTipos from "./secciones/config/actividades/lista/ActividadesTipos.js";
import ActividadTipo from "./secciones/config/actividades/individual/ActividadTipo.js";
import ListaPrecios from "./secciones/precios/ListaPrecios.js";
import ProcesoActividad from "./secciones/proceso/actividad/ProcesoActividad";
import PlanesActividades from "./secciones/config/planificacion/lista/PlanesActividades";
import PlanActividades from "./secciones/config/planificacion/individual/PlanActividades";
import JunoConfig from "./secciones/config/juno/JunoConfig";
import Templates from "./secciones/config/template/lista/Templates.js";
import TemplateIndividual from "./secciones/config/template/individual/TemplateIndividual.js";
import Instrumental from "./secciones/config/instrumental/lista/Instrumental";
import Instrumento from "./secciones/config/instrumental/individual/Instrumento";
import EstadosCertificados from "./secciones/config/estadoCertificado/lista/EstadosCertificados.js";
import EstadoCertificado from "./secciones/config/estadoCertificado/individual/EstadoCertificado.js";
import HallazgoTipos from "./secciones/config/hallazgoTipo/lista/HallazgoTipos.js";
import CategoriasArchivos from "./secciones/config/categoriasArchivos/CategoriasArchivos.js";
import AccionesCliente from "./secciones/config/accionesCliente/AccionesCliente.js";
import AccionClienteIndividual from "./secciones/config/accionesCliente/AccionClienteIndividual.js";
import Acreditaciones from "./secciones/acreditacion/Acreditaciones.js";
import AcreditacionIndividual from "./secciones/acreditacion/AcreditacionIndividual.js";
import SitioTipos from "./secciones/config/sitioTipos/SitioTipos.js";
import Documentos from "./secciones/config/documento/lista/Documentos";
import Documento from "./secciones/config/documento/individual/Documento";
import Cumplimiento from "./secciones/cumplimiento/Cumplimiento";
import DocumentoCarpetas from "./secciones/config/documento/carpeta/DocumentoCarpetas";
import HallazgoTipo from "./secciones/config/hallazgoTipo/individual/HallazgoTipo.js";
import Eulas from "./secciones/config/eula/lista/Eulas.js";
import Eula from "./secciones/config/eula/individual/Eula.js";
import RequerimientosFormacionColaboradores from "./secciones/config/auditor/requerimientosFormacion/lista/RequerimientosFormacionColaboradores.js";
import RequerimientoFormacionColaborador from "./secciones/config/auditor/requerimientosFormacion/individual/RequerimientoFormacionColaborador.js";
import AuditoriaSG from "./secciones/auditoriaSG/individual/AuditoriaSG.js";
import TableroSeguimiento from "./secciones/tableroSeguimiento/TableroSeguimiento.js";
import AuditoriasSG from "./secciones/gestion/AuditoriasSG";
import CertificadosSinPlanificacion from "./secciones/gestion/CertificadosSinPlanificacion";
import Importaciones from "./secciones/gestion/Importaciones";
import Facturacion from "./secciones/facturacion/Facturacion.js";
import IndicadoresFacturacion from "./secciones/indicadores/facturacion/IndicadoresFacturacion.js";

export default function Router() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const accesoTipo = useRol();

  // Verifica si está en proceso de autenticación (tiene oauthtoken en URL o está en /login)
  const oauthtoken = searchParams.get("oauthtoken");
  const enProcesoDeLogin = oauthtoken || location.pathname === "/login";

  // Verifica si hay token en localStorage
  const tieneToken = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);

  // Solo muestra el contenido autenticado si no está en proceso de login y tiene token
  const mostrarContenidoAutenticado = !enProcesoDeLogin && tieneToken;

  // Si el usuario es de tipo Tablero (28), redirige a /tablero-seguimiento.
  // Se usa accesoTipo (el rol) y no accesoId: el id de la fila de Acceso lo
  // asigna la base y es distinto en cada organismo.
  useEffect(() => {
    if (accesoTipo === 28 && location.pathname !== "/tablero-seguimiento") {
      navigate("/tablero-seguimiento", { replace: true });
    }
  }, [accesoTipo, location.pathname, navigate]);

  // Si está en proceso de login, solo muestra el Footer y la ruta de Login
  if (!mostrarContenidoAutenticado) {
    return (
      <div
        css={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: "1440px",
          padding: "0px 15px"
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </div>
    );
  }

  return (
    <div
      css={{
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "1440px",
        padding: "0px 15px"
      }}
    >
      <Routes key={location.pathname}>
        <Route path="/" element={<Tablero />} />
        <Route path="/login" element={<Login />} />
        <Route path="/config" element={<ConfigPortada />} />
        <Route path="/config/general" element={<GeneralConfig />} />
        <Route path="/config/integraciones" element={<Integraciones />} />
        <Route
          path="/config/administradores"
          element={
            <ConPermiso
              clave="admin.administradores"
              alternativa={<NotFound />}
            >
              <Administradores />
            </ConPermiso>
          }
        />
        <Route
          path="/config/administradores/:usuarioId"
          element={
            <ConPermiso
              clave="admin.administradores"
              alternativa={<NotFound />}
            >
              <Administrador />
            </ConPermiso>
          }
        />
        <Route path="/procesotipos" element={<ProcesoTipos />} />
        <Route path="/contadores" element={<Contadores />} />
        <Route path="/numeracion" element={<Numeracion />} />
        <Route path="/documentocarpetas" element={<DocumentoCarpetas />} />
        <Route path="/esquemas" element={<Esquemas />} />
        <Route path="/esquemas/:esquemaId" element={<Esquema />} />
        <Route path="/reporte" element={<Reporte />} />
        <Route path="/norma" element={<Normas />} />
        <Route path="/norma/:normaId" element={<Norma />} />
        <Route path="/muestra" element={<Muestras />} />
        <Route path="/muestra/:muestraId" element={<Muestra />} />
        <Route path="/caja/:cajaId" element={<Caja />} />
        <Route path="/proceso/:procesoId" element={<ProcesoLayout />}>
          <Route index element={<Navigate to="detalles" replace />} />
          <Route path="detalles" element={<ProcesoDetalles />} />
          <Route path="productos" element={<ProcesoProductos />} />
          <Route path="actividades" element={<ProcesoActividad />} />
          <Route
            path="actividades/:actividadId"
            element={<ProcesoActividad />}
          />
          <Route path="certificado" element={<ProcesoCertificado />} />
          <Route path="certificado/:certificadoId" element={<Certificado />} />
        </Route>
        <Route path="/procesos/nuevo" element={<NuevoProceso />} />
        <Route
          path="/procesos/solicitudes/:solicitudId"
          element={<Solicitud />}
        />

        {/* Las propuestas entran en el permiso de facturación */}
        <Route
          path="/propuesta/:propuestaId"
          element={
            <ConPermiso clave="admin.facturacion" alternativa={<NotFound />}>
              <PropuestaComercial />
            </ConPermiso>
          }
        />

        <Route
          path="/propuestasabana/nueva/:clienteId"
          element={
            <ConPermiso
              clave="admin.facturacion"
              nivel="full"
              alternativa={<NotFound />}
            >
              <PropuestaSabanaNueva />
            </ConPermiso>
          }
        />
        <Route
          path="/propuestasabana/:propuestaId"
          element={
            <ConPermiso clave="admin.facturacion" alternativa={<NotFound />}>
              <PropuestaSabana />
            </ConPermiso>
          }
        />

        <Route path="/busqueda/:buscar" element={<BusquedaResultado />} />
        <Route path="/juguetes/operaciones" element={<JuguetesOperaciones />} />
        <Route path="/certificadotipos" element={<CertificadoTipos />} />

        <Route path="/template" element={<Templates />} />
        <Route path="/template/:templateId" element={<TemplateIndividual />} />

        <Route path="/lista-precios" element={<ListaPrecios />} />

        <Route path="/actividades/tipos" element={<ActividadesTipos />} />
        <Route
          path="/actividades/tipos/:actividadTipoId"
          element={<ActividadTipo />}
        />

        <Route
          path="/config/planes-actividades"
          element={<PlanesActividades />}
        />
        <Route
          path="/config/planes-actividades/:planId"
          element={<PlanActividades />}
        />
        <Route path="/estadocertificado" element={<EstadosCertificados />} />
        <Route
          path="/estadocertificado/:estadoCertificadoId"
          element={<EstadoCertificado />}
        />
        <Route path="/hallazgotipo" element={<HallazgoTipos />} />
        <Route
          path="/config/categoriasarchivos"
          element={<CategoriasArchivos />}
        />
        <Route
          path="/config/accionescliente"
          element={<AccionesCliente />}
        />
        <Route
          path="/config/accionescliente/:accionId"
          element={<AccionClienteIndividual />}
        />
        <Route path="/acreditacion" element={<Acreditaciones />} />
        <Route path="/acreditacion/:acreditacionId" element={<AcreditacionIndividual />} />
        <Route path="/eula" element={<Eulas />} />
        <Route path="/eula/:eulaId" element={<Eula />} />
        <Route path="/sitiotipos" element={<SitioTipos />} />
        <Route path="/documento" element={<Documentos />} />
        <Route path="/documento/:documentoId" element={<Documento />} />
        <Route path="/cumplimiento" element={<Cumplimiento />} />
        <Route
          path="/hallazgotipo/:hallazgoTipoId"
          element={<HallazgoTipo />}
        />

        <Route
          path="/certificadotipos/:certificadoTipoId"
          element={<CertificadoTipo />}
        />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/clientes/:clienteId" element={<ClienteLayout />}>
          <Route index element={<Navigate to="informacion" replace />} />
          <Route path="informacion" element={<ClienteInformacion />} />
          <Route path="procesos" element={<ProcesosCliente />} />
          <Route path="sitios" element={<ClienteSitios />} />
          <Route
            path="facturas"
            element={
              <ConPermiso clave="admin.facturacion" alternativa={<NotFound />}>
                <ClienteFacturas />
              </ConPermiso>
            }
          />
          <Route path="configuracion" element={<ClienteConfiguracion />} />
        </Route>
        <Route path="comunicaciones" element={<Comunicaciones />} />
        <Route path="/proveedores/laboratorios" element={<Laboratorios />} />
        <Route
          path="/proveedores/laboratorios/:laboratorioId"
          element={<Laboratorio />}
        />
        <Route path="/proveedores/auditortipos" element={<AuditorTipos />} />
        <Route
          path="/proveedores/auditortipos/:auditorTipoId"
          element={<AuditorTipoDetalle />}
        />
        <Route path="/proveedores/auditores" element={<Auditores />} />
        <Route path="/proveedores/auditores/:auditorId" element={<Auditor />} />

        <Route
          path="/formacioncolaborador"
          element={<RequerimientosFormacionColaboradores />}
        />

        <Route
          path="/formacioncolaborador/:formacionId"
          element={<RequerimientoFormacionColaborador />}
        />

        <Route path="/instrumental" element={<Instrumental />} />
        <Route path="/instrumental/:instrumentoId" element={<Instrumento />} />
        <Route path="/comunicacion/configeventos" element={<Eventos />} />
        <Route
          path="/comunicacion/configeventos/:eventoTipoId"
          element={<Evento />}
        />
        <Route path="/comunicacion/enviados" element={<Enviados />} />
        <Route path="/juno/config" element={<JunoConfig />} />
        <Route path="/auditoriasg/:auditoriaId" element={<AuditoriaSG />} />
        {/* Gestión dejó de ser una página: ahora es una categoría del menú */}
        <Route path="/gestion" element={<Navigate to="/auditoriasg" replace />} />
        <Route path="/auditoriasg" element={<AuditoriasSG />} />
        {/* Actividades sin decisor volvió a ser un accordion de la portada */}
        <Route
          path="/actividades-sin-decisor"
          element={<Navigate to="/" replace />}
        />
        <Route
          path="/certificados-sin-planificacion"
          element={<CertificadosSinPlanificacion />}
        />
        <Route path="/importaciones" element={<Importaciones />} />
        <Route
          path="/facturacion"
          element={
            <ConPermiso clave="admin.facturacion" alternativa={<NotFound />}>
              <Facturacion />
            </ConPermiso>
          }
        />
        <Route
          path="/indicadores/facturacion"
          element={
            <ConPermiso clave="admin.facturacion" alternativa={<NotFound />}>
              <IndicadoresFacturacion />
            </ConPermiso>
          }
        />
        <Route path="/tablero-seguimiento" element={<TableroSeguimiento />} />
        <Route path="/archivo/:hash" element={<ArchivoPreviewPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
